import React, { useState } from 'react';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import BfwLogo from '../assets/logo-1.png';
import './sidebar.css';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';

function Sidebar() {
    const [sidebar, setSidebar] = useState(false);
    const [subnavStates, setSubnavStates] = useState({});

    const showSidebar = () => setSidebar(prev => !prev);

    // Nur ein Subnav gleichzeitig öffnen oder alles schließen
    const toggleSubnav = (index) => {
        setSubnavStates((prevState) => {
            const isOpen = prevState[index];
            return isOpen ? {} : { [index]: true };
        });
    };

    // Klick auf Hauptmenü
    const handleNavClick = (item, index) => {
        if (item.subNav) {
            toggleSubnav(index);
        } else {
            setSidebar(false);
            setSubnavStates({});
        }
    };

    // Klick auf Untermenü
    const handleSubNavClick = () => {
        setSidebar(false);
        setSubnavStates({});
    };

    // Keyboard-Unterstützung für Enter/Space auf "pseudo-buttons"
    const handleKeyToggle = (event, item, index) => {
        if (!item.subNav) return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleSubnav(index);
        }
    };

    return (
        <IconContext.Provider value={{ color: '#fff' }}>
            <div className='navbar'>
                {/* Hamburger: bleibt ein Link, bekommt aber Button-Rolle + ARIA */}
                <Link
                    to="#"
                    className='menu-bars h'
                    onClick={(e) => { e.preventDefault(); showSidebar(); }}
                    role="button"
                    aria-label={sidebar ? 'Navigation schließen' : 'Navigation öffnen'}
                    aria-expanded={sidebar}
                    aria-controls="sidebar-nav"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            showSidebar();
                        }
                    }}
                >
                    <FaIcons.FaBars aria-hidden="true" focusable="false" />
                </Link>
            </div>

            {/* Navigation nur rendern, wenn Sidebar sichtbar ist → 
                keine aria-hidden + fokussierbare Elemente mehr */}
            {sidebar && (
                <nav
                    id="sidebar-nav"
                    className={sidebar ? 'nav-menu active' : 'nav-menu'}
                    aria-label="Hauptnavigation"
                >
                    <ul className='nav-menu-items'>
                        {/* Close-Icon: ebenfalls als Button gekennzeichnet */}
                        <Link
                            to="#"
                            className='menu-bars x'
                            onClick={(e) => {
                                e.preventDefault();
                                setSidebar(false);
                                setSubnavStates({});
                            }}
                            role="button"
                            aria-label="Navigation schließen"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setSidebar(false);
                                    setSubnavStates({});
                                }
                            }}
                        >
                            <AiIcons.AiOutlineClose aria-hidden="true" focusable="false" />
                        </Link>

                        {SidebarData.map((item, index) => (
                            <React.Fragment key={index}>
                                <li
                                    className={item.cName}
                                    onClick={() => handleNavClick(item, index)}
                                    // Fokusierbar machen, wenn Subnav existiert (für Keyboard-Toggle)
                                    tabIndex={item.subNav ? 0 : -1}
                                    onKeyDown={(e) => handleKeyToggle(e, item, index)}
                                    aria-haspopup={item.subNav ? 'true' : undefined}
                                    aria-expanded={item.subNav ? !!subnavStates[index] : undefined}
                                >
                                    <Link
                                        to={item.path || '#'}
                                        onClick={(e) => {
                                            // Wenn Subnav vorhanden: Navigation toggeln,
                                            // ansonsten: normales Verhalten + Sidebar schließen
                                            if (item.subNav) {
                                                e.preventDefault();
                                            } else {
                                                setSidebar(false);
                                                setSubnavStates({});
                                            }
                                        }}
                                    >
                                        {item.icon && React.cloneElement(item.icon, {
                                            'aria-hidden': true,
                                            focusable: false
                                        })}
                                        <span>{item.title}</span>
                                        {item.subNav && (
                                            <span className='dropdown-icon' aria-hidden="true">
                                                {subnavStates[index] ? item.iconOpened : item.iconClosed}
                                            </span>
                                        )}
                                    </Link>
                                </li>

                                {item.subNav && subnavStates[index] && item.subNav.map((subItem, subIndex) => (
                                    <li
                                        key={`${index}-${subIndex}`}
                                        className='nav-sub-item'
                                        onClick={handleSubNavClick}
                                    >
                                        <Link to={subItem.path}>
                                            <span>{subItem.title}</span>
                                        </Link>
                                    </li>
                                ))}
                            </React.Fragment>
                        ))}

                        <div className="flex-row">
                            <div className="main_links">
                                <p>© 2025 BFW - Bundesforschungszentrum für Wald</p>
                            </div>
                            <div className="flex-2">
                                <a href="https://www.bfw.gv.at/" target="_blank" rel="noreferrer">
                                    <img src={BfwLogo} alt="bfw-logo" className="llogo" />
                                </a>
                            </div>
                        </div>
                    </ul>
                </nav>
            )}
        </IconContext.Provider>
    );
}

export default Sidebar;
